interface IProps {
  width?: number;
  height?: number;
  color?: string;
}

export const IconArrow = ({
  color = "#0084FF",
  height = 25,
  width = 25,
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7803 13.2803C19.0732 12.9874 19.0732 12.5126 18.7803 12.2197L14.7803 8.21967C14.4874 7.92678 14.0126 7.92678 13.7197 8.21967C13.4268 8.51256 13.4268 8.98744 13.7197 9.28033L16.4393 12H6.25C5.83579 12 5.5 12.3358 5.5 12.75C5.5 13.1642 5.83579 13.5 6.25 13.5H16.4393L13.7197 16.2197C13.4268 16.5126 13.4268 16.9874 13.7197 17.2803C14.0126 17.5732 14.4874 17.5732 14.7803 17.2803L18.7803 13.2803Z"
        fill={color}
      />
    </svg>
  );
};
